<template>
  <div class="wrap_xszn">
    <div class="xszn_tabs">
      <ul>
        <li v-for="(item, index) in menus" :class="{active: isCurrentMenu(item)}" :key="index"
            @click="handleMenu(item, index)">
          <p >
            <i class="czzn-tbs-icon" :class="item.className"></i>
            {{ item.name }}
          </p>
        </li>
      </ul>
    </div>
    <div class="czzn-main">
      <router-view/>
    </div><!--xszn_main-->
  </div>
</template>
<script>
export default {
  name: 'spxx',
  data() {
    return {
      menus: [
        { name: '全部', path: '/spxx/qbsp', className: 'czzn-tbs-cpjs' },
        { name: '产品介绍', path: '/spxx/cpjs', className: 'czzn-tbs-cpjs' },
        { name: '账套管理', path: '/spxx/ztgl', className: 'czzn-tbs-ztgl' },
        { name: '初始设置', path: '/spxx/cssz', className: 'czzn-tbs-cssz' },
        { name: '发票管理', path: '/spxx/fpgl', className: 'czzn-tbs-fpgl' },
        { name: '凭证处理', path: '/spxx/pzcl', className: 'czzn-tbs-pzcl' },
        { name: '账表查询', path: '/spxx/zbcx', className: 'czzn-tbs-zbcx' },
        { name: '财务报表', path: '/spxx/cwbb', className: 'czzn-tbs-cwbb' },
        { name: '期末处理', path: '/spxx/qmcl', className: 'czzn-tbs-qmcl' },
        { name: '纳税申报', path: '/spxx/nssb', className: 'czzn-tbs-nssb' },
      ],
    };
  },
  methods: {
    handleMenu(menu, index) {
      if (index === 0) {
        this.$router.push(menu.path);
      }
    },
    isCurrentMenu(menu) {
      return menu.path === this.$route.fullPath;
    },
  },
};
</script>
